import { render } from "./NearestDistributors.vue?vue&type=template&id=3bed5550&scoped=true"
import script from "./NearestDistributors.vue?vue&type=script&lang=js"
export * from "./NearestDistributors.vue?vue&type=script&lang=js"

import "./NearestDistributors.vue?vue&type=style&index=0&id=3bed5550&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bed5550"]])

export default __exports__